<script lang="ts">
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import Chart from "chart.js";
import { Bar } from "vue-chartjs";

/**
 * Chartjs Barコンポーネント
 */
@Component
export default class BarChart extends Mixins(Bar) {
  /** グラフに表示する内容 */
  @Prop({
    default: () => {
      return {};
    }
  })
  chartData!: Chart.ChartData;

  /**
   * vue lifecycle created
   */
  public created(): void {
    return;
  }

  /**
   * vue lifecycle mounted
   */
  public mounted(): void {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              callback: function (value: any, index: any, values: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      // ツールチップ
      tooltips: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "rgba(0, 0, 0, .2)",
        borderWidth: 1,
        titleFontColor: "rgba(0, 0, 0, 1)",
        titleFontSize: 14,
        bodyFontColor: "rgba(0, 0, 0, 1)",
        bodyFontSize: 14,
        bodySpacing: 8,
        xPadding: 8,
        yPadding: 12
      }
    });

    return;
  }

  /**
   * propの値が更新されたらグラフを再描画する
   * chartjsのグラフ再描画を使用すると、高さがリセットされるようなので自前で行う
   */
  @Watch("chartData")
  public chartDataChanged(): void {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              callback: function (value: any, index: any, values: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      // ツールチップ
      tooltips: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "rgba(0, 0, 0, .2)",
        borderWidth: 1,
        titleFontColor: "rgba(0, 0, 0, 1)",
        titleFontSize: 14,
        bodyFontColor: "rgba(0, 0, 0, 1)",
        bodyFontSize: 14,
        bodySpacing: 8,
        xPadding: 8,
        yPadding: 12
      }
    });

    return;
  }
}
</script>
